import type { IPaymentSettingsItem } from "web/types/Payment";

const canPayOnlinePayment = (payments: IPaymentSettingsItem[]) => {
  return payments
    ? !!payments.find((payment) => payment.type === "ONLINE_PAYMENT")
    : null;
};

export default canPayOnlinePayment;
